import {IComponentController, IHttpPromise, IHttpService} from "angular";
import {CustomerSubscriptionStatus} from "../model/CustomerSubscriptionStatus";
import {getAbsoluteUrl} from "../../utils/urlUtill";
import {MarketingTemplateType} from "../../customer_profile/model/MarketingTemplateType";

export class CustomerSubscriptionsService implements IComponentController {

    public static instance = ['$http', CustomerSubscriptionsService];


    constructor(private $http: IHttpService) {
    }

    public getCustomerSubscriptions = (customerId: number, marketingTemplateType: MarketingTemplateType): IHttpPromise<CustomerSubscriptionStatus[]> => {
        return this.$http({
            method: 'GET',
            url: getAbsoluteUrl('api/subscriptions/sendgrid'),
            params: {
                'customer_id': customerId,
                'template_type': marketingTemplateType
            }
        })
    }
}